import app from '../../forum/app';
import Component from '../../common/Component';
import Button from '../../common/components/Button';
import classList from '../../common/utils/classList';
import HeaderListItem from './HeaderListItem';
import ItemList from '../../common/utils/ItemList';
import Avatar from '../../common/components/Avatar';
/**
 * The `Notification` component abstract displays a single notification.
 * Subclasses should implement the `icon`, `href`, and `content` methods.
 */
export default class Notification extends Component {
  view(vnode) {
    var _this$href;
    const notification = this.attrs.notification;
    const href = (_this$href = this.href()) != null ? _this$href : '';
    const fromUser = notification.fromUser();
    return m(HeaderListItem, {
      className: classList('Notification', "Notification--".concat(notification.contentType()), [!notification.isRead() && 'unread']),
      avatar: m(Avatar, {
        user: fromUser || null
      }),
      icon: this.icon(),
      content: this.content(),
      excerpt: this.excerpt(),
      datetime: notification.createdAt(),
      href: href,
      onclick: this.markAsRead.bind(this),
      actions: this.actionItems().toArray()
    });
  }
  actionItems() {
    const items = new ItemList();
    if (!this.attrs.notification.isRead()) {
      items.add('markAsRead', m(Button, {
        className: "Notification-action Button Button--link",
        icon: "fas fa-check",
        "aria-label": app.translator.trans('core.forum.notifications.mark_as_read_tooltip'),
        onclick: e => {
          e.preventDefault();
          e.stopPropagation();
          this.markAsRead();
        }
      }), 100);
    }
    return items;
  }

  /**
   * Get the name of the icon that should be displayed in the notification.
   */

  /**
   * Get the URL that the notification should link to.
   */

  /**
   * Get the content of the notification.
   */

  /**
   * Get the excerpt of the notification.
   */

  /**
   * Mark the notification as read.
   */
  markAsRead() {
    var _app$session$user, _app$session$user$unr;
    if (this.attrs.notification.isRead()) return;
    (_app$session$user = app.session.user) == null || _app$session$user.pushAttributes({
      unreadNotificationCount: ((_app$session$user$unr = app.session.user.unreadNotificationCount()) != null ? _app$session$user$unr : 1) - 1
    });
    this.attrs.notification.save({
      isRead: true
    });
  }
}
flarum.reg.add('core', 'forum/components/Notification', Notification);